import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { Tasks } from "@components/modules/resource-planning/tasks";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import {
  NavigationProject,
  NavigationProjects,
} from "@src/components/widgets/AppSubNav";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    fullWidth
    noTopMargin
    noBottomMargin
    title={t`Project tasks`}
    navigation={<NavigationProjects projectId={id} />}
  >
    <Tasks variant="project" navigation={<NavigationProject id={id} />} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/tasks")({
  component: RouteComponent,
});
